if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentMediaIndex = 0;

        this.handlePreviousClick = this.handlePreviousClick.bind(this);
        this.handleNextClick = this.handleNextClick.bind(this);
      }

      connectedCallback() {
        super.connectedCallback();

        const previousButton = this.querySelector('.shafaf-modal-arrow--prev');
        const nextButton = this.querySelector('.shafaf-modal-arrow--next');

        if (previousButton) {
          previousButton.addEventListener('click', this.handlePreviousClick);
        }

        if (nextButton) {
          nextButton.addEventListener('click', this.handleNextClick);
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);

        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(
          this.querySelectorAll('.product-media-modal__content > [data-media-id]')
        );
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');

        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        let activeIndex = mediaItems.findIndex(
          (media) => media.getAttribute('data-media-id') === mediaId
        );

        if (activeIndex === -1) {
          activeIndex = 0;
        }

        this.currentMediaIndex = activeIndex;

        this.activateMedia(activeIndex);
      }

      activateMedia(index) {
        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        if (index < 0) {
          index = mediaItems.length - 1;
        }

        if (index >= mediaItems.length) {
          index = 0;
        }

        this.currentMediaIndex = index;

        mediaItems.forEach((media) => {
          media.classList.remove('active');
        });

        const activeMedia = mediaItems[index];

        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }

        /* Update counter */
        const counter = this.querySelector('.shafaf-modal-counter');

        if (counter) {
          const current = counter.querySelector('.shafaf-modal-current');
          const total = counter.querySelector('.shafaf-modal-total');

          if (current) {
            current.textContent = index + 1;
          }

          if (total) {
            total.textContent = mediaItems.length;
          }
        }
      }

      handlePreviousClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        this.activateMedia(this.currentMediaIndex - 1);
      }

      handleNextClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        this.activateMedia(this.currentMediaIndex + 1);
      }
    }
  );
}
/* =========================================================
   SHAFaf MODAL - SLIDE DIRECTION
   ========================================================= */

document.addEventListener('click', function (event) {
  const nextButton = event.target.closest('.shafaf-modal-arrow--next');
  const prevButton = event.target.closest('.shafaf-modal-arrow--prev');

  if (nextButton) {
    document.documentElement.setAttribute(
      'data-shafaf-modal-direction',
      'next'
    );
  }

  if (prevButton) {
    document.documentElement.setAttribute(
      'data-shafaf-modal-direction',
      'prev'
    );
  }
}, true);